module.exports = __webpack_public_path__ + "static/don43-58f017ebb2d2178f54f4c71d486fab7a.jpg";